import axiosInstance from "./axiosInstance";

export const offersServices = {
    // Отримання всіх офферів
    async getAllOffers() {
        try {
            const response = await axiosInstance.get("/offers/offers");
            return response.data;
        } catch (error) {
            console.error("Error getting offers:", error);
            throw error;
        }
    },

    async deleteOffer(id) {
        try {
            const response = await axiosInstance.delete(`/offers/offers/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error deleting offer:", error);
            throw error;
        }
    },

    async updateOffer(offerData) {
        try {
            const response = await axiosInstance.put(
                `/offers/offers/${offerData.id}`,
                offerData
            );
            return response.data;
        } catch (error) {
            console.error("Error updating offer:", error);
            throw error;
        }
    },

    // Створення нового оффера
    async createOffer(offerData) {
        try {
            const response = await axiosInstance.post(
                "/offers/offers",
                offerData
            );
            return response.data;
        } catch (error) {
            console.error("Error creating offer:", error);
            throw error;
        }
    },

    // Отримання всіх вертикалей
    async getVerticals() {
        try {
            const response = await axiosInstance.get("/offers/verticals");
            return response.data;
        } catch (error) {
            console.error("Error getting verticals:", error);
            throw error;
        }
    },

    // Створення нової вертикалі
    async createVertical(verticalData) {
        try {
            const response = await axiosInstance.post(
                "/offers/verticals",
                verticalData
            );
            return response.data;
        } catch (error) {
            console.error("Error creating vertical:", error);
            throw error;
        }
    },

    // Отримання всіх партнерок
    async getPartnerships() {
        try {
            const response = await axiosInstance.get("/offers/partnerships");
            return response.data;
        } catch (error) {
            console.error("Error getting partnerships:", error);
            throw error;
        }
    },

    // Створення нової партнерки
    async createPartnership(partnershipData) {
        try {
            const response = await axiosInstance.post(
                "/offers/partnerships",
                partnershipData
            );
            return response.data;
        } catch (error) {
            console.error("Error creating partnership:", error);
            throw error;
        }
    }
};
